<template>
  <div class="enterprisesSetBox">
    <el-form
      v-if="!isShowEditor"
      ref="form"
      v-loading="enterpriseLoading"
      :model="result"
      label-width="140px"
      label-position="left"
    >
      <el-form-item label="企业名称:">
        <div v-if="result.name && canEditEnterprise" class="enterprisesBox item">
          <p class="row-name">
            {{ result.name }}
          </p>
          <el-button class="edit" type="text" @click="canEditEnterpriseMe">修改</el-button>
        </div>
        <div v-else>
          <el-input
            ref="name-input"
            v-model="result.name"
            :maxlength="10"
            :minlength="2"
            placeholder="支持中文、字母、数字的组合，2-10个字符"
            class="enterprise"
            :class="enterpriseError ? 'error' : null"
            @blur="enterpriseNameBlur()"
          />
          <span v-show="enterpriseError" class="errorText">
            <i class="iconfont icon-ai54" />
            支持中文、字母、数字的组合，2-10个字符
          </span>
          <i v-show="result.name" class="propmptText">支持中文、字母、数字的组合，2-10个字符</i>
        </div>
      </el-form-item>
      <el-form-item label="小程序名称:">
        <div v-if="result.wxmininame && canEditWxmini" class="enterprisesBox item">
          <p class="row-name">
            {{ result.wxmininame }}
          </p>
          <el-button class="edit" type="text" @click="canEditWxminiMe">修改</el-button>
        </div>
        <div v-else>
          <el-input
            ref="wxmini-input"
            v-model="result.wxmininame"
            placeholder="支持中文、字母、数字的组合，2-6个字符"
            class="wxmini"
            :maxlength="6"
            :minlength="2"
            :class="miniNameError ? 'error' : null"
            @blur="wxminiNameBlur()"
          />
          <span v-show="miniNameError" class="errorText">
            <i class="iconfont icon-ai54" />
            支持中文、字母、数字的组合，2-6个字符
          </span>
          <i v-show="result.wxmininame" class="propmptText">
            支持中文、字母、数字的组合，2-6个字符
          </i>
        </div>
      </el-form-item>
      <el-form-item class="wxmini-name-lable" label="小程序检视账号:">
        <div class="wxminiName item item2">
          <div class="leftContent row-name">
            <div class="uesr-info-wrap">
              <p class="name">
                用户名 |
                <i class="name-password name-words">
                  {{ result.ExaminName ? result.ExaminName : '-' }}
                </i>
              </p>
              <p class="password">
                密码 |
                <i class="password-words name-password">
                  {{ result.ExaminPassword ? result.ExaminPassword : '-' }}
                </i>
              </p>
            </div>

            <el-button class="edit" type="text" @click="dialogAddExaminAccount = true">
              编辑
            </el-button>
          </div>
          <div>
            <AddExaminAccount
              v-if="dialogAddExaminAccount"
              :account-name="result.ExaminName"
              :account-pass-word="result.ExaminPassword"
              @hideDialog="hideAddExaminAccountDialog"
              @saveNamePassword="saveExamin"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item class="select-warp" label="小程序检视领域:">
        <div class="select item item2">
          <!-- 检视账号多选 -->
          <el-select
            v-model="accounts"
            class="accountsSelects"
            multiple
            :multiple-limit="2"
            placeholder="请选择"
          >
            <el-option
              v-for="item in accountsFields"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="法律&隐私声明:">
        <div class="lawContent item item2 row-name">
          <div class="upLeftBox">
            <p v-if="!companyConfig.privacyLaw.updateTime" class="none">-</p>
            <!-- <p class="upError">
              上传失败 <i class="time">上传时间:2020/8/30</i>
            </p> -->
            <p v-else class="uped">
              已上传
              <i class="time">上传时间:{{ companyConfig.privacyLaw.updateTime }}</i>
            </p>
          </div>
          <div class="upRightBox">
            <el-button type="text" class="edit" @click="editDialog('law')">编辑</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="授权书:">
        <div class="authorization item item2 row-name">
          <div class="upLeftBox">
            <p v-if="!companyConfig.authorization.updateTime" class="none">-</p>
            <!-- <p class="upError">
              上传失败<i class="time">上传时间:2020/8/30</i>
            </p> -->
            <p v-else class="uped">
              已上传
              <i class="time">上传时间:{{ companyConfig.authorization.updateTime }}</i>
            </p>
          </div>
          <div class="upRightBox">
            <el-button type="text" class="edit" @click="editDialog('right')">编辑</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item class="upLoad mini" label="小程序Logo:">
        <FileUpload
          v-model="result.wxminiLogo"
          @onError="FileUploadError"
          @beforeAvatarUpload="beforeAvatarUpload"
        />
        <div class="mask-words" style="pointer-events: none">
          <div class="shadow">重新上传</div>
        </div>
        <span v-if="upLogoError && !result.wxminiLogo" class="upErrorText">
          <i class="iconfont icon-ai54" />
          请选择高度小于70px,长度小于70px,且格式为png的图片
        </span>
        <p class="promptText">高度小于70px，长度小于70px，且格式为png</p>
      </el-form-item>
      <el-form-item class="upLoad enterprise" label="企业Logo:">
        <FileUpload
          v-model="result.enterpriseLogo"
          @onError="FileUploadEnterpriseError"
          @beforeAvatarUpload="beforeEnterpriseUpload"
        />
        <div class="mask-words" style="pointer-events: none">
          <div class="shadow">重新上传</div>
        </div>
        <span v-if="upEnterpriseLogoError && !result.enterpriseLogo" class="upErrorText">
          <i class="iconfont icon-ai54" />
          请选择高度50px,长度小于244px,且格式为png的图片
        </span>
        <p class="promptText">高度50px，长度小于244px，且格式为png</p>
      </el-form-item>
      <el-form-item class="submit" label-width="0">
        <el-button type="primary" @click="onSubmit">保存</el-button>
      </el-form-item>
    </el-form>
    <DialogQuillEdit
      :dialog-title="dialogTitle"
      :dialog-visible="privacyLawDialog"
      :content="editContent"
      @closeDialog="closePrivacyLawDialog"
      @upData="upDataPrivacyLaw"
      @getContent="getContent"
    />
  </div>
</template>
<script>
import AddExaminAccount from '../addExaminAccount';
import api from './api';
import FileUpload from '@/components/fileUpload/index';
import DialogQuillEdit from '@/components/dialog-quill-edit/index';
import { dateFormat } from '@/utils/time.js';
import {
  getDomainInfoListApi, // 获取领域列表
} from '@/api/setUser';

export default {
  name: 'EnterprisesSet',
  components: {
    AddExaminAccount,
    FileUpload,
    DialogQuillEdit,
  },
  data() {
    return {
      enterpriseLoading: true,
      dialogTitle: '',
      currentDialog: '', // 当前弹窗   'right' 授权   law 法律
      privacyLawDialog: false, // 法律弹窗
      authorizationLawDialog: false, // 授权弹窗
      enterpriseNameRegE: /^[\u4e00-\u9fa5a-zA-Z0-9]{2,10}$/ /* 企业名称正则表达式 */,
      miniProgramNameRegE: /^[\u4e00-\u9fa5a-zA-Z0-9]{2,6}$/ /* 小程序名称正则表达式 */,
      form: {
        name: '',
        wxmininame: '',
      },
      editContent: '',
      result: {
        name: '' /* 企业名称 */,
        wxmininame: '' /* 微信小程序名称 */,
        ExaminName: '' /* 检视账号用户名 */,
        ExaminPassword: '' /* 检视账号密码 */,
        authorization: '' /* 授权书*/,
        privacyLaw: '' /* 隐私和法律 */,
        wxminiLogo: '' /* 小程序logo */,
        enterpriseLogo: '' /* 企业logo */,
      },
      accounts: [] /* 检视账号选中领域 */,
      accountsFields: [
        {
          value: 0,
          label: '内科',
        },
        {
          value: 1,
          label: '外科',
        },
        {
          value: 3,
          label: '耳鼻喉科',
        },
        {
          value: 4,
          label: '皮肤科',
        },
        {
          value: 5,
          label: '呼吸科',
        },
      ] /* 检视账号选择领域项 */,
      canEditEnterprise: true /* 能否编辑企业名称 */,
      enterpriseError: false /* 企业名称输入错误 */,
      canEditWxmini: true /* 能否编辑小程序名称 */,
      miniNameError: false /* 小程序输入错误 */,
      dialogAddExaminAccount: false /* 检视账号弹窗显示隐藏 */,
      upLogoError: false /* 上传小程序logo出错 */,
      upEnterpriseLogoError: false /* 上传企业logo出错 */,
      isShowEditor: false /* 是否显示编辑 */,
      htmlText: '' /* 编辑内容 */,
      companyConfig: {
        name: {} /* 企业名称 */,
        wxmininame: {} /* 微信小程序名称 */,
        userInfo: {},
        authorization: {} /* 授权书*/,
        privacyLaw: {} /* 隐私和法律 */,
        wxminiLogo: {} /* 小程序logo */,
        enterpriseLogo: {} /* 小程序logo */,
      } /* 后台返回的配置信息 */,
    };
  },
  mounted() {},
  created() {
    this.getQueryTag();
    this.getQueryCompanyConfig();
  },
  methods: {
    beforeAvatarUpload() {
      this.upLogoError = true;
    },
    beforeEnterpriseUpload() {
      this.upEnterpriseLogoError = true;
    },
    /**
     * 小程序文件上传失败
     */
    FileUploadError() {
      this.upLogoError = true;
      console.log('上传失败了');
    },
    /**
     * 企业文件上传失败
     */
    FileUploadEnterpriseError() {
      this.upEnterpriseLogoError = true;
      console.log('上传失败了');
    },
    /**
     * 打开法律弹窗
     */
    editDialog(type) {
      this.privacyLawDialog = true;
      this.currentDialog = type;
      const isLaw = type === 'law';
      this.$nextTick(() => {
        isLaw ? (this.dialogTitle = '编辑法律&隐私声明') : (this.dialogTitle = '授权书');

        this.editContent = this.result[isLaw ? 'privacyLaw' : 'authorization'];
      });
    },
    /**
     *更新富文本数据
     */
    upDataPrivacyLaw() {
      this.privacyLawDialog = false;
    },

    /**
     * 关闭弹窗
     */
    closePrivacyLawDialog() {
      this.privacyLawDialog = false;
    },
    /**
     * 获取法律富文本的值
     */
    getContent(e) {
      this.currentDialog === 'law' ? (this.result.privacyLaw = e) : (this.result.authorization = e);
    },
    /**
     * 查询标签
     */
    async getQueryTag() {
      const params = {
        labelType: 20,
        enabled: 1,
      };
      getDomainInfoListApi();

      const res = await this.$requestData(api.queryTag, params);
      if (res.data?.code === 0) {
        const data = res.data?.data;
        this.accountsFields = data?.map((item) => ({
          // ...item,
          value: item.id,
          label: item.labelName,
        }));
      }
    },
    /**
     *更改企业配置
     */
    async saveCompanyConfig() {
      this.enterpriseLoading = true;
      const {
        name /* 企业名称 */,
        wxmininame /* 微信小程序名称 */,
        ExaminName /* 检视账号用户名 */,
        ExaminPassword /* 检视账号密码 */,
        authorization /* 授权书*/,
        privacyLaw /* 隐私和法律 */,
        wxminiLogo /* 小程序logo */,
        enterpriseLogo /* 企业logo */,
      } = this.result;
      const labelIds = this.accounts;
      const params = [
        {
          configType: 10,
          configText: encodeURIComponent(JSON.stringify(privacyLaw)),
          id: this.companyConfig.privacyLaw.id || '',
          labelIds: [],
        },
        {
          configType: 20,
          configText: encodeURIComponent(JSON.stringify(authorization)),
          id: this.companyConfig.authorization.id || '',
          labelIds: [],
        },
        {
          configType: 30,
          configText: JSON.stringify({ companyName: name }),
          id: this.companyConfig.name.id || '',
          labelIds: [],
        },
        {
          configType: 40,
          configText: JSON.stringify({ appletName: wxmininame }),
          id: this.companyConfig.wxmininame.id || '',
          labelIds: [],
        },
        {
          configType: 50,
          configText: JSON.stringify({
            applet_logo_elongate: enterpriseLogo,
          }), //
          id: this.companyConfig.enterpriseLogo.id || '',
          labelIds: [],
        },
        {
          configType: 70,
          configText: JSON.stringify({
            applet_logo_square: wxminiLogo,
          }), //
          id: this.companyConfig.wxminiLogo.id || '',
          labelIds: [],
        },
        {
          configType: 60,
          configText: JSON.stringify({
            loginName: ExaminName,
            passWord: ExaminPassword,
          }),
          id: this.companyConfig.userInfo.id || '',
          labelIds,
        },
      ];

      const res = await this.$requestData(api.modifyCompanyConfig, {
        requests: params,
      });
      if (res.data?.code === 0) {
        this.enterpriseLoading = false;
        this.$message.success('保存成功');
        this.getQueryCompanyConfig();
      }
    },
    /**
     *查询企业配置
     */
    async getQueryCompanyConfig() {
      const params = {};
      this.enterpriseLoading = true;

      const res = await this.$requestData(api.queryCompanyConfig, params);
      if (res.data?.code === 0) {
        const data = res.data?.data;
        const companyConfig = {};
        data?.forEach((item) => {
          //    name: "" /* 企业名称 */,
          // wxmininame: "" /* 微信小程序名称 */,
          // ExaminName: "" /* 检视账号用户名 */,
          // ExaminPassword: "" /* 检视账号密码 */,
          // authorization: "" /* 授权书*/,
          // privacyLaw: "" /* 隐私和法律 */,
          // wxminiLogo: "" /* 小程序logo */,
          // 10法律&隐私文件，20授权书，30企业名称，40小程序名称，50小程序LOGO，60小程序检视账号

          if (item.configType === 60) {
            this.result.ExaminName = JSON.parse(item.configText).loginName;
            this.result.ExaminPassword = JSON.parse(item.configText).passWord;
            this.accounts = item.labelIds;
            this.$set(this.companyConfig, 'userInfo', item);
          } else if (item.configType === 50) {
            const enterpriseLogo = JSON.parse(item.configText).applet_logo_elongate;
            this.result.enterpriseLogo = enterpriseLogo;
            this.$set(this.companyConfig, 'enterpriseLogo', item);
          } else if (item.configType === 70) {
            this.result.wxminiLogo = JSON.parse(item.configText).applet_logo_square;
            this.$set(this.companyConfig, 'wxminiLogo', item);
          } else if (item.configType === 40) {
            this.result.wxmininame = JSON.parse(item.configText).appletName;
            companyConfig.wxmininame = item;
            this.$set(this.companyConfig, 'wxmininame', item);
          } else if (item.configType === 30) {
            this.result.name = JSON.parse(item.configText).companyName;
            companyConfig.name = item;
            this.$set(this.companyConfig, 'name', item);
          } else if (item.configType === 20) {
            this.result.authorization = JSON.parse(decodeURIComponent(item.configText));
            item.updateTime = dateFormat(new Date(item.updateTime), 'YYYY/MM/dd');

            this.$set(this.companyConfig, 'authorization', item);
          } else if (item.configType === 10) {
            this.result.privacyLaw = JSON.parse(decodeURIComponent(item.configText));
            item.updateTime = dateFormat(new Date(item.updateTime), 'YYYY/MM/dd');
            this.$set(this.companyConfig, 'privacyLaw', item);
          }
        });
        this.enterpriseLoading = false;
      }
    },

    /**
     *提交验证·
     */

    verifyParams() {
      const {
        // name /* 企业名称 */,
        // wxmininame /* 微信小程序名称 */,
        ExaminName /* 检视账号用户名 */,
        ExaminPassword /* 检视账号密码 */,
        authorization /* 授权书*/,
        privacyLaw /* 隐私和法律 */,
        wxminiLogo /* 小程序logo */,
        enterpriseLogo /* 企业logo */,
      } = this.result;
      if (!this.enterpriseNameBlur()) {
        this.$message.error('请输入正确的企业名称');
        return false;
      }
      if (!this.wxminiNameBlur()) {
        this.$message.error('请输入微信小程序名称');
        return false;
      }
      if (!ExaminName && ExaminPassword) {
        this.$message.error('请输入账户名或密码');
        return false;
      }
      if (!authorization.replace(/<.*?>/gi, '').trim()) {
        this.$message.error('请上传授权书');
        return false;
      }
      if (!privacyLaw.replace(/<.*?>/gi, '').trim()) {
        this.$message.error('请上传法律和隐私和声明');
        return false;
      }
      if (!wxminiLogo) {
        this.$message.error('请上传小程序logo');
        return false;
      }
      if (!enterpriseLogo) {
        this.$message.error('请上传企业logo');
        return false;
      }

      return true;
    },
    /**
     *点击提交按钮
     */
    async onSubmit() {
      if (this.verifyParams()) {
        this.saveCompanyConfig();
      }
    },
    /* 企业名称改变触发 */
    enterpriseNameChange(value) {
      const type = this.enterpriseNameRegE.test(value.trim());
      if (type) {
        this.result.name = value;
        this.canEditEnterprise = true;
        this.enterpriseError = false;
        return true;
      }
      this.enterpriseError = true;
      return false;
    },
    /* 企业名称失去焦点触发 */
    enterpriseNameBlur() {
      const type = this.enterpriseNameRegE.test(this.result.name.trim());
      if (type) {
        // this.result["name"] = this.form.name;
        this.canEditEnterprise = true;
        this.enterpriseError = false;
        return true;
      }
      this.enterpriseError = true;
      this.canEditEnterprise = false;
      return false;
    },
    /* 企业名称点击修改触发 */
    canEditEnterpriseMe() {
      this.canEditEnterprise = false;
      this.$nextTick(() => {
        // 自动获取焦点 element组件autofocus失效
        this.$refs['name-input'].$refs.input.focus();
      });
    },
    /* 小程序名称改变触发 */
    wxminiNameChange(value) {
      const type = this.miniProgramNameRegE.test(value.trim());
      if (type) {
        this.result.wxmininame = value;
        this.canEditWxmini = true;
        this.miniNameError = false;
        return true;
      }
      this.miniNameError = true;
      return false;
    },
    /* 小程序名称失去焦点触发 */
    wxminiNameBlur() {
      const type = this.miniProgramNameRegE.test(this.result.wxmininame.trim());

      if (type) {
        // this.result["wxmininame"] = this.form.wxmininame;
        this.canEditWxmini = true;
        this.miniNameError = false;
        return true;
      }
      this.canEditWxmini = false;
      this.miniNameError = true;
      return false;
    },
    /* 企业名称点击修改触发 */
    canEditWxminiMe() {
      this.canEditWxmini = false;
      this.$nextTick(() => {
        // 自动获取焦点 element组件autofocus失效
        this.$refs['wxmini-input'].$refs.input.focus();
      });
    },
    /* 关闭检视账号弹窗 */
    hideAddExaminAccountDialog() {
      this.dialogAddExaminAccount = false;
    },
    /* 获取检视账号 */
    saveExamin(obj) {
      this.result.ExaminName = obj.name;
      this.result.ExaminPassword = obj.password;
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
